(function() { module.exports = window["VueMeta"]; }());